var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"credit-card-payment"}},[_c('vue-loading',{attrs:{"active":_vm.isLoading,"is-full-page":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }